import { render, staticRenderFns } from "./DeliverySection.vue?vue&type=template&id=29fb0262&scoped=true&"
import script from "./DeliverySection.vue?vue&type=script&lang=ts&"
export * from "./DeliverySection.vue?vue&type=script&lang=ts&"
import style0 from "./DeliverySection.vue?vue&type=style&index=0&id=29fb0262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb0262",
  null
  
)

export default component.exports